const searchableFields = ['lastName', 'firstName', 'company', 'position'];

/**
 * searchStr - will be split by space and the condition is like (field1 like part1 or filed2 like part1...) and (field1 like part2 or filed2 like part2...) and ...
 * excludingUsers - these users will be excluded from the selection
 * groupFilter - filter by group
 */
interface ProfileFilterParams {
    searchStr: string;
    additionalFields?: string[];
    excludingUsers?: number[];
    groupFilter?: any;
    eventId?: string;
    participantTypes?: string[] | undefined;
    tagsIds?: string[];
}

/**
 * returns user profile filter for a search string
 */
const prepareProfileFilter = (params: ProfileFilterParams) => {
    const parts: string[] = params.searchStr.split(' ');
    const result: any[] = [];
    const words: string[] = parts.map((part: string) => `(?i).*${part}.*`);

    result.push({
        $search: [
            [...searchableFields, ...(params.additionalFields || [])],
            words
        ]
    });

    if (params.excludingUsers?.length) {
        result.push({ userId: { $nin: params.excludingUsers } });
    }

    if (params.eventId) {
        result.push({
            userId: {
                $inQuery: {
                    schema: "EventMemberships",
                    where: {
                        eventSchemaId: process.env.VUE_APP_EVENTS_SCHEMA,
                        eventObjectId: params.eventId,
                        type: {
                            $in: (params.participantTypes && params.participantTypes?.length) ? params.participantTypes : ['speaker', 'participant']
                        },
                        status: {
                            $in: ['confirmed', 'mandatory']
                        },
                        isDeleted: false
                    },
                    "selectField": "userId"
                }
            },

        })
    }

    if (params.tagsIds?.length) {
        result.push({
            tagsIds: {
                $containsAny: params.tagsIds
            }
        })
    }

    if (params.groupFilter && Object.keys(params.groupFilter).length) {
        result.push(params.groupFilter);
    }
    return { $and: result }
}

/**
 * returns user profile filter for a tags
 * @param tagsIds
 * @param interestingTagIds
 */
const prepareRecommendedCondition = (tagsIds: string[], interestingTagIds: string[]) => {
    return {
        $or: [
            {
                tagsIds: {
                    $containsAny: interestingTagIds
                }
            },
            {
                interestingTagIds: {
                    $containsAny: tagsIds
                }
            }
        ]
    }
}

/**
 * returns array with order settings
 * @param searchString - string which will be searched for
 * @param direction - order direction
 * @param manualOrder - manual sort field name
 */
const getOrderSettings = (searchString: string, direction: "asc" | "desc" = "asc", manualOrder?: string) => {
    const order: any[] = [];

    if (searchString) {
        direction = direction === "asc" ? "desc" : "asc";
        order.push({
            operation: "$similarity",
            direction: direction,
            columns: [
                { "firstName": 2 },
                { "lastName": 3 },
                { "company": 1 },
                { "position": 1 }
            ],
            strings: searchString
        })
    }
    else {
        if (manualOrder) {
            order.push({
                column: manualOrder,
                direction: direction
            })
        }
    }


    return order.length > 0 ? [...order] : null;
}

const prepareUserIdsFilter = (userIds: number[]) => {
    return {
        userId: {
            $in: userIds
        }
    }
}

export { prepareProfileFilter, getOrderSettings, prepareRecommendedCondition, prepareUserIdsFilter}
